import React, { useState } from 'react'
import { CssBaseline, Typography, Button, Box, TextField, Avatar, useTheme, Container, Collapse, Stack } from '@mui/material'

import { useSearch, useNavigate } from '@tanstack/react-router'
import { useAuth } from '../_shared/authService'

export const ConfirmUserPage: React.FC = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const search = useSearch({ from: '/_auth_not_required/confirm' })
  const { confirmSignUp } = useAuth()
  const [email, setEmail] = useState(search.email || '')
  const [confirmationCode, setConfirmationCode] = useState('')
  const [errorMessage, setErrorMessage] = useState<string>()
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const confirmSignUpResult = await confirmSignUp(email, confirmationCode)
    if (confirmSignUpResult.isSuccess) {
      navigate({ to: '/signin' })
    } else {
      setErrorMessage(`確認コードが正しくありません: ${confirmSignUpResult.error}`)
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          アカウント確認
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="メールアドレス"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmationCode"
            label="認証コード"
            type="text"
            value={confirmationCode}
            onChange={(e) => setConfirmationCode(e.target.value)}
          />
          <Collapse in={!!errorMessage}>
            <Stack
              direction="row"
              alignItems="center"
              sx={{ borderWidth: 1, borderStyle: 'solid', borderColor: theme.palette.error.main, borderRadius: 1 }}
              spacing={1}
              px={2}
              py={1}
            >
              <Typography variant="caption" color="error">
                {errorMessage}
              </Typography>
            </Stack>
          </Collapse>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            送信
          </Button>
        </Box>
      </Box>
    </Container>
  )
}
export default ConfirmUserPage
